<template>
  <div id="demo-basic-card">
    <div id="dashboard-analytics">
      <div class="vx-row">
        <div class="vx-card header p-2 pt-0">
          <div class="vx-row scroll-header">
            <div class="ml-6 md:w-1/6 mt-2" style="float:left;min-width: 175px">
              <v-select class="text-size" v-model="mergeAction" :options="optionalMergeAction" :placeholder="$t('managerKeyword.placeholderAction')"></v-select>
            </div>
            <div class="ml-6 md:w-1/12 mt-2" style="float:left;min-width: 115px">
              <vs-button @click="selectMergeAction">{{$t('exportFile.apply')}}</vs-button>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <span style="font-size: 14px;font-weight: bold">{{$t('realtimeChart.boxTime')}}: </span>
              <date-range-picker
                class="ml-2"
                ref="picker"
                :locale-data="{ format: 'dd/mm/yyyy' }"
                :opens="'right'"
                @update="filterReport"
                v-model="dateRange">
              </date-range-picker>
            </div>

            <div class="vx-col md:w-1/3 w-full mt-1"
                style="display: flex;justify-content: flex-end;position: absolute;right: 0;border-left: solid 1px;">
              <span class="text-special-info mt-3"> {{ $t('exportFile.number') }} : </span>
              <b-button-group class="group-button ml-2">
                <vs-button
                  style="height:40px;border-right: white 1px solid"
                  vs-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-for="(button, indexButton) in optionButtonSelect" :key="indexButton"
                  :style="{height:'40px', background: button.bg}"
                  @click="changePageSize(button)"
                >
                  {{ button.label }}
                </vs-button>
              </b-button-group>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-4 ">
        <vs-table stripe :data="optionReportCalendar" class="w-full" :noDataText="this.$t('noData')">
          <template>
            <vs-tr style="background:#f3f2f7 !important">
              <vs-th class="vx-col md:w-1/12 w-full mt-2 text-header">
                <vs-checkbox  v-model="checkAllReport" style="float:left;margin-left: 10.5px;" @change="checkAll"></vs-checkbox>{{ $t('exportFile.stt') }}
              </vs-th>
              <vs-th class="vx-col md:w-1/4 w-full mt-2 text-header">{{ $t('exportFile.nameExport') }}</vs-th>
              <vs-th class="vx-col md:w-1/6 w-full mt-2 text-header">{{ $t('exportFile.status') }}</vs-th>
              <vs-th class="vx-col md:w-1/4 w-full mt-2 text-header">{{ $t('exportFile.calendar') }}</vs-th>
              <vs-th class="vx-col md:w-1/6 w-full mt-2 text-header">{{ $t('exportFile.createDate') }}</vs-th>
            </vs-tr>
            <vs-tr v-for="(item,indexReport) in optionReportCalendar" :key="indexReport">
              <vs-td class="text-number"><vs-checkbox v-model="item.checked" style="float:left"></vs-checkbox>{{ indexReport+1 }}</vs-td>
              <vs-td class="text-number">{{ item.name }}</vs-td>
              <vs-td class="text-number" style="color: rgb( 47 128 237);">
                <div class="vx-col">
                  <div class="vx-row " @click="changeStatus(item)" v-if="item.statusReport">
                    <feather-icon
                      icon="PauseIcon"
                      class="float-left ml-4"
                      style="width: 1.5rem;color: #2F80ED"
                    >
                    </feather-icon>
                    <span class="ml-1" style="font-size: 12px;color: rgb(185 185 195)">{{ $t('projectAndTopic.isActive') }}</span>
                  </div>
                  <div class="vx-row ml-1" @click="changeStatus(item)" v-else
                  >
                    <feather-icon
                      icon="PlayCircleIcon"
                      class="float-left"
                      style="color: rgba(var(--vs-danger), 1);width: 1.7rem"

                    >
                    </feather-icon>
                    <span class="ml-1" style="font-size: 12px;color: rgb(185 185 195)">{{ $t('projectAndTopic.pause') }}</span>
                  </div>
                </div>
              </vs-td>
              <vs-td  style="font-size: 12px;color: rgb(185 185 195)">
                <span v-if="item.reportType == 'DAY' " > {{ item.displayType }} ({{item.sendDaily}} {{ $t('exportFile.daily') }}) </span>
                <span v-if="item.reportType == 'WEEK' " >{{ item.displayType }} ({{item.sendDaily}} {{$t('exportFile.hours')}} {{item.displayWeek }} {{$t('exportFile.week')}})  </span>
              </vs-td>
              <vs-td style = "color: rgb( 47 128 237);" class = "text-number">{{ item.time }}</vs-td>
              <vs-td>
                <div class="drop-keyword mt-1 ml-6">
                  <!--                        vx-card n chủ đề-->
                  <vs-dropdown class="cursor-pointer mt-2">
                    <feather-icon
                      icon="MoreVerticalIcon"
                      class=""
                      style="color: rgb(110 107 123);width: 1.7rem"
                    >
                    </feather-icon>
                    <vs-dropdown-menu>
                      <ul style="min-width: 228pt">
                        <li class="border-bottom flex py-2 px-4 cursor-pointer cursor-auto">
                          <div class=" py-2 px-4">
                            <div class="vx-row">
                             <span v-if="item.statusReport" style="font-size: 12px">
                                        {{$t('projectAndTopic.status')}}: {{ $t('projectAndTopic.isActive') }}
                                      </span>
                              <span v-else style="font-size: 12px">
                                        {{$t('projectAndTopic.status')}}: {{ $t('projectAndTopic.pause') }}
                                      </span>
                              <div style="margin-left: 98pt;" @click="changeStatus(item)" v-if="item.statusReport"
                              >
                                <feather-icon
                                  icon="PauseIcon"
                                  class="float-left"
                                  style="color: #2F80ED;width: 1.7rem"
                                >
                                </feather-icon>
                              </div>
                              <div style="margin-left: 75pt;" @click="changeStatus(item)" v-else>
                                <feather-icon
                                  icon="PlayCircleIcon"
                                  class="float-left"
                                  style="color:rgb(241 43 44);width: 1.7rem"
                                >
                                </feather-icon>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="border-bottom py-2 px-4 cursor-pointer cursor-auto ">
                          <div class="vx-col">
                            <span
                              style="color: rgb( 185 185 195)">{{ $t('projectAndTopic.info') }}</span>
                            <div class="info-topic">
                              <div>
                                <span>{{ $t('projectAndTopic.creator') }} :{{userInfo.email}} </span>
                              </div>
                              <div>
                                <span>{{ $t('projectAndTopic.createDate') }} : {{ item.time }} </span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="editItem(item)">
                          <feather-icon
                            icon="Edit3Icon"
                            style="vertical-align:middle;width:1rem"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1">{{ $t('exportFile.edit') }}</span>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="copyFile(item)">
                          <feather-icon
                            icon="CopyIcon"
                            style="vertical-align:middle;width:1rem"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1"
                          >{{ $t('exportFile.copy') }}</span>
                        </li>
                        <li class="border-bottom flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                            @click="confirmDeleteReport(item)">
                          <feather-icon
                            icon="Trash2Icon"
                            style="vertical-align:middle;width:1rem"
                          >
                          </feather-icon>
                          <span class="font-action ml-2 mt-1"
                          >{{ $t('exportFile.delete') }}</span>
                        </li>
                      </ul>
                    </vs-dropdown-menu>

                  </vs-dropdown>

                </div>

              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-card custom-card">
          <div class="vx-col md:w-1/2 w-full m-auto ml-4">
              <div class="component">
                <span class="content-page">{{ $t('source.showing')}}: </span>
                <span class="text-page">{{totalElements > 0 ? pageNumber + 1 : 0}} - {{(((pageNumber + 1 ) * pageSize) > totalElements) ?  totalElements : ((this.pageNumber + 1 ) * this.pageSize) }}/{{totalElements}} </span>
                <span class="content-page">{{ $t('source.content')}}</span>
              </div>
            </div>
            <vs-pagination
              :total ="totalPages"
              :max="maxPageNumbers"
              v-model="currentPage"
              @change="onChangePage"
            ></vs-pagination>
        </div>
      </div>
    </div>
    <PopupConfirm :active="activePopup" :on-success="onSuccess" :close="closePopup"/>
  </div>
</template>

<script>
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import {BButtonGroup, BButton, BCardText} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import vSelect from "vue-select";
import PopupConfirm from "../../notify/PopupConfirm";

export default {
  components: {
    vSelect,
    DateRangePicker,
    BButtonGroup,
    BButton,
    BCardText,
    PopupConfirm
  },
  directives: {
    Ripple
  },
  data() {
    return {
      ids : [],
      optionalMergeAction:[
        {label:this.$t('exportFile.copyCheckbox'), value:0},
        {label:this.$t('exportFile.deleteCheckbox'), value:1}
      ],
      checkAllReport :  false,
      checked : false,
      valueMergeAction:null,
      confirmDelete:false,
      activePopup:false,
      sendDaily : null,
      email : null,
      sendDailyCheck : true,
      nameDay : null,
      nameDayCheck : true,
      userInfo : [],
      reportType: null,
      organizationId: null,
      statusReport: true,
      optionReportCalendar: [],
      name: null,
      createdBy: null,
      createdDate: null,
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 29);
          date.setHours(0, 0, 0);
          return date;
        })()
      },
      optionButtonSelect: [
        {label: '10', id: 1, value: 10, bg: '#2F80ED'},
        {label: '25', id: 2, value: 25, bg: '#2F80ED'},
        {label: '50', id: 3, value: 50, bg: '#2F80ED'}
      ],
      countElementPage: 0,
      pageNumber: 0,
      pageSize: 10,
      totalElements: 0,
      //pagination
      totalPages: 0,
      maxPageNumbers: 6,
      currentPage: 1,
      nameItem:null,
      optionalType: [
        {label: this.$t('exportFile.brandHealthByDay'), value: 'DAY'},
        {label: this.$t('exportFile.brandHealthByWeek'), value: 'WEEK'}
      ],
      optionalTime: [
        {label: this.$t('exportFile.monday'), value: 'Monday'},
        {label: this.$t('exportFile.tuesday'), value: 'Tuesday'},
        {label: this.$t('exportFile.wednesday'), value: 'Wednesday'},
        {label: this.$t('exportFile.thursday'), value: 'Thursday'},
        {label: this.$t('exportFile.friday'), value: 'Friday'},
        {label: this.$t('exportFile.saturday'), value: 'Saturday'},
        {label: this.$t('exportFile.sunday'), value: 'Sunday'},
      ],
    }
  },
  computed : {
    mergeAction:{
      get:function(){
        let object=  this.optionalMergeAction.find(el => el.value === this.valueMergeAction);
        if(!object) return null;
        return{
          label:object.label,
          value:object.value
        }
      },
      set:function(object){
        this.valueMergeAction = object ? object.value : null
      }
    }
  },
  methods: {
    checkboxCombinedAction : function () {
      this.optionalMergeAction[0].label = this.$t('exportFile.copyCheckbox')
      this.optionalMergeAction[1].label = this.$t('exportFile.deleteCheckbox')
      // this.dataPreview.avgTime = this.$t('managerKeyword.notEstimate')
    },
    selectMergeAction: function(){
      if (this.valueMergeAction == null) {
        return;
      }
      if (!this.optionReportCalendar.filter(el => el.checked == true).length) {
        return this.$vs.notify({
          text: this.$t('exportFile.errPooled'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      if(this.valueMergeAction == 0){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('exportFile.titleCopyPooled'),
          text: this.$t('exportFile.textCopyPooled'),
          accept: this.saveCopyData,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }
      if(this.valueMergeAction == 1){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('exportFile.titleDeletePooled'),
          text: this.$t('exportFile.textDeletePooled'),
          accept: this.deleteByListReportId,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }

    },
    saveCopyData: function(){
      this.optionReportCalendar.filter(el => el.checked == true).forEach(data =>{
        this.copyFile(data);
      });
    },
    checkAll: function(){
      const data = this.optionReportCalendar.filter(el => el.id);
      data.forEach(el =>{
        el.checked = false
      });
      if(this.checkAllReport){
        data.forEach(el =>{
          el.checked = true

        })
      }
    },
    reloadData() {
      this.filterReport()
    },
    changeStatus : function (item) {
      const payload = {
        ...item,
        statusReport: !item.statusReport,
      }
      this.$vs.loading();
      this.$report.post(`/report/update/${item.id}`, payload).then(() => {
        this.filterReport();
        this.$vs.loading.close();
        this.initScreen();
        return this.showUpdateCrawl(item)
      }).catch(err => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text:
            err.response.data.message ||
            err.response.data.error_description ||
            err.response.data.error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
    },
    showUpdateCrawl(item) {
      const isStatusData = !item.statusReport;
      this.$store.commit('UPDATE_USER_SUCCESS', true);
      this.$vs.notify({
        color: 'primary',
        text: ` ${isStatusData ? this.$t('exportFile.continue') : this.$t('exportFile.pause')} ` + ` ${this.$t('exportFile.auto')}` + ` "${item.name}" `,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    editItem(item){
      this.$router.push(`/user/v2/report-calendar-update?id=${item.id}`).catch(() => {
      })
    },
    copyFile(item){
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$vs.loading();
      let payload = [{
        startDate: item.startDate,
        endDate: item.endDate,
        startData : item.startData,
        dataTypes : item.dataTypes,
        reportTopicList: item.reportTopicList,
        beanTypes: item.beanTypes,
        sendDaily : item.sendDaily,
        name: item.name + '(copy)' ,
        expirationNotice : item.expirationNotice,
        reportType : item.reportType,
        organizationId : item.organizationId,
        organizationName : item.organizationName,
        emails : item.emails,
        ccEmails : item.ccEmails,
        title : item.title,
        nameDay : item.nameDay,
        sendNow : item.sendNow,
        fileAttached :item.fileAttached,
        userId : item.userId,
        customerType: userInfo.customerType
      }]
      const path = '/report/create';
      this.$report.post(path, payload)
        .then( () => {
          this.filterReport();
          this.$vs.loading.close();
          return this.$vs.notify({
            text : this.$t('exportFile.copySuccess'),
            iconPack: "feather",
            icon: "icon-alert",
            color: "primary"
          });
        }).catch(err => {
        this.filterReport();
        this.$vs.loading.close();
        return this.$vs.notify({
          text:
            err.response.data.message ||
            err.response.data.error_description ||
            err.response.data.error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
    },
    languageData(){
      this.filterReport().then(()=> {

      });
    } ,
    filterReport() {
      let userInfo = JSON.parse(localStorage.userInfo);
      this.organizationId = userInfo.organization.id;
      const payload = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        organizationId: userInfo.organization.id,
        from: this.dateRange.startDate,
        to: this.dateRange.endDate
      }
      this.$vs.loading();
      this.$report.post(`report/all`, payload).then((res) => {
        this.$vs.loading.close();
        this.totalElements = res.data.length
        this.optionReportCalendar = res.data.slice(this.pageSize *  this.pageNumber,(this.pageNumber + 1) * this.pageSize);
        this.optionReportCalendar = this.optionReportCalendar.map(el => {
          let time = el.startDate ? moment(el.startDate).format("DD/MM/YYYY HH:mm") : "";
          let displayType = this.optionalType.find(item => item.value == el.reportType).label;
          let displayWeek = el.reportType == "WEEK" ? this.optionalTime.find(item => item.value == el.nameDay).label : "";
          el.checked = false;
          return {
            time:time,
            name: el.name,
            startDate : el.startDate,
            organizationId: el.organizationId,
            displayType: displayType,
            displayWeek: displayWeek,
            reportType: el.reportType,
            sendDaily : el.sendDaily,
            nameDay : el.nameDay,
            emails:el.emails,
            ccEmails:el.ccEmails,
            title : el.title,
            organizationName:el.organizationName,
            expirationNotice:el.expirationNotice,
            startData:el.startData,
            reportTopicList:el.reportTopicList,
            userId:el.userId,
            sendNow:el.sendNow,
            fileAttached:el.fileAttached,
            dataTypes:el.dataTypes,
            beanTypes:el.beanTypes,
            endDate:el.endDate,
            statusReport: el.statusReport,
            id:el.id,
          }
        })
        this.totalPages = parseInt((res.data.length)/this.pageSize);
        if (this.totalPages * this.pageSize < res.data.length) this.totalPages +=1;
        this.totalElements = res.data.length;
        this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
        const data = localStorage.getItem('userInfo');
        const info = JSON.parse(data);
        this.userInfo.email = info.email;
      });
    },
    onChangePage: function (event) {

      const page = String(event);
      this.pageNumber = parseInt(page) - 1
      this.filterReport();
    },
    changePageSize: function(event){
      this.optionButtonSelect.forEach(el => el.bg = '#2F80ED !important')
      event.bg = "#1561C3 !important"
      this.pageSize = event.value
      this.filterReport();
    },
    onSuccess(){
      if (this.confirmDelete){
        this.deleteRecord();
      }
    },
    closePopup(){
      this.activePopup = false;
      this.confirmDelete =false;
    },
    confirmDeleteReport(item) {
      this.nameItem = item.name
      this.activePopup = true;
      this.confirmDelete = true;
    },
    deleteByListReportId:function(){
      this.$vs.loading();
          const request={
            ids : []
          };
          this.optionReportCalendar.filter(el => el.checked).forEach(value =>{
            request.ids.push(value.id);
          })
          this.$report.post(`/report/deletes`, request).then(() =>{
            this.filterReport();
            return this.$vs.notify({
              text: this.$t('exportFile.textSuccessDelete'),
              iconPack:'feather',
              icon:'icon-alert',
              color:'primary'
            })
          }).catch((err) =>{
            this.$vs.loading.close();
            return this.$vs.notify({
              text: err.response.data.message || err.response.data.error_description || err.response.data.error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          })
    },
    deleteRecord() {
      let payload ={
        name:this.nameItem,
        organizationId:this.organizationId
      }
      this.$vs.loading();
      this.$report.post(`/report/delete`,payload).then(() => {
        this.filterReport();
        this.activePopup = false;
        this.confirmDelete =false;
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: this.$t('exportFile.deleteSuccess') ,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      }).catch((err) => {
        this.$vs.loading.close();
        this.activePopup = false;
        this.confirmDelete =false;
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    initScreen(){

    },
  },
  async created() {
    this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
    this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
    this.initScreen();
    this.filterReport();
    this.$eventBus.$on('i18n', () => {
      this.checkboxCombinedAction();
    })
    this.checkboxCombinedAction()
  },
  mounted(){
  }

}
</script>


<style scoped>
.text-header {
  font-size: 12px;
  font-weight: bold;
  color: rgb(94 88 115);
  letter-spacing: 1pt;
}

.text-number {
  font-size: 12px;
  letter-spacing: 0.44px;
  line-height: 24px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-special-info {
  font-size: 13px;
  color: rgb(94 88 115);
}
</style>
<style lang="css">
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}

.daterangepicker {
  border-left: none !important;
}

.export-file {
  position: absolute;
  right: 2rem;
}

.reportrange-text {
  border-radius: 10px;
  height: 37px;
  line-height: 27px;
}

.title-size {
  font-size: 16px !important;
}

.text-size {
  font-size: 12px !important;
}

.minus-top {
  margin-top: -24px;
}

.selected-topic .vs__selected {
  color: #fff;
  background-color: #5C6BC0;
}

.selected-topic .v-select .vs__dropdown-toggle .vs__deselect svg {
  stroke: #fff;
  opacity: 1;
}

.ti-input {
  border-radius: 5px;
}
.custom-card {
  height: 50px;
  display: flex !important;
  -webkit-box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 2%) !important;
}
.text-page {
    font-size: 14px;
    color: #3ba1ff;
}
.content-page {
    color: #caccd6;
    font-size: 14px;
}
</style>
<style lang="css">
.vs-con-table{
  z-index: 0;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
</style>
